module.exports = __webpack_public_path__ + "static/media/rating.6f5013bb.svg";